/**
 * Regitry of javascript elements
 */
define('elements',['controller'], function(controller) {
	var callbacks = [];
	
	var exports = {
		/**
		 * Registers a function that should be applied to all new HTML
		 */
		register: function(callback) {
			callbacks.push(callback);
			callback($('body'));
		},
		
		/**
		 * Enables elements for the given HTML (either jQuery or selector)
		 */
		enable: function(elements) {
			elements = $(elements);
			callbacks.forEach(function(callback) {
				callback(elements);
			});
		}
	};
	
	controller.on(function() {
		exports.enable($('#page'));
		exports.enable($('#footer'));
	});
	
	return exports;
});

